<template lang="html">
	<div class="look_img">
		<div class="img_swiper" @click="showImg" v-if="lookImg.length > 1">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide shade_img" v-for="(a, index) in lookImg" :key="index">
						<img :src="a" alt="">
					</div>
				</div>
			</div>
		</div>
		<div class="img_alone" @click="showImg" v-else>
			<img :src="lookImg" alt="">
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper/swiper-bundle.min.js'
	import 'swiper/swiper-bundle.min.css'

	export default {
		props: ['images'],
		data() {
			return {
				lookImg: '',
			}
		},
		mounted() {

		},
		methods: {
			thisgood() {
				new Swiper('.swiper-container', {
					watchSlidesProgress: true,
					observer: true,
					observeParents: true,
				});
			},
			show(a) {
				this.lookImg = a;

				this.$nextTick(function() {
					this.thisgood();
				}, 0);
			},
			showImg() {
				this.$parent.noneImg(false);
			}
		}
	}
</script>

<style lang="css" scoped>
	.look_img {
		width: 100%;
		height: 100%;
	}

	.img_swiper {
		height: 100%;
	}

	.swiper2 {
		height: 100%;
	}

	.shade_img {
		height: 100%;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
	}

	.shade_img img {
		width: 100%;
	}

	/* 单张 */
	.img_alone {
		height: 100%;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
	}

	.img_alone img {
		width: 100%;
	}
</style>
